import { ChevronRight } from '@mui/icons-material';
import { Menu, MenuItem, MenuProps, Tooltip } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { MouseEvent } from 'react';

export type BasicMenuListItem = {
    text: string;
    onClick?: (e?: MouseEvent<HTMLElement>) => void;
    disabled?: boolean;
    noAutoClose?: boolean;
    showChevron?: boolean;
    tooltip?: string;
    tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
};

export const BasicMenuList = ({
    items,
    paperSx,
    PaperProps,
    ...props
}: MenuProps & { items: BasicMenuListItem[]; paperSx?: SystemStyleObject }) => {
    const handleClick = (onClick?: (e?: MouseEvent<HTMLElement>) => void, autoclose?: boolean) => (e: MouseEvent<HTMLLIElement>) => {
        e.stopPropagation();
        onClick?.(e);
        if (autoclose) props.onClose?.(e, 'backdropClick');
    };
    return (
        <Menu
            {...props}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left', ...props.anchorOrigin }}
            transformOrigin={{ vertical: 'top', horizontal: 'right', ...props.transformOrigin }}
            PaperProps={{
                ...PaperProps,
                sx: ({ palette }) => ({ borderRadius: '8px', backgroundColor: palette.primary[300], ...paperSx })
            }}
        >
            {items.map((el) => (
                <Tooltip title={el.tooltip} key={el.text} placement={el.tooltipPlacement}>
                    <span>
                        <MenuItem key={el.text} onClick={handleClick(el.onClick, !el.noAutoClose)} disabled={el.disabled}>
                            {el.text} {el.showChevron && <ChevronRight />}
                        </MenuItem>
                    </span>
                </Tooltip>
            ))}
        </Menu>
    );
};
